module.exports = __webpack_public_path__ + "static/43122-d6a0cf52f0f14718701c1671ae84f2a4.jpg";